import { getProductConfigs } from 'src/clients';
import { RootState } from '../reducers/rootReducer';
import { ACTION_TYPES } from '../types/productConfigTypes';

export const loadProductConfigs = (isForceLoad = false) => {
  return {
    types: [
      ACTION_TYPES.LOAD_PRODUCT_CONFIG_LIST,
      ACTION_TYPES.LOAD_PRODUCT_CONFIG_LIST_SUCCESS,
      ACTION_TYPES.LOAD_PRODUCT_CONFIG_LIST_FAILED,
    ],
    client: getProductConfigs,
    shouldCallAPI: (state: RootState) =>
      isForceLoad ||
      (state.productConfigs.data.length === 0 &&
        !state.productConfigs.isLoading),
  };
};
